import { Environment } from './environment.interfaces';

export const environment: Environment = {
  production: false,
  CONNECT_URL: 'https://develop.virtamed.cloud/',
  API_HOST: 'https://appdevelop.virtamed.cloud/api/',
  version: 'local build',
};
